export type Theme = 'light' | 'dark';

export const THEME_ATTRIBUTE = 'data-theme';
